<template>
  <div>
    <v-data-table
        id="affiliateMainTable"
        :items="invoices"
        :headers="cols"
        :loading="loading.mainTable"
        class="anty-user-panel-billing-main-table"
        hide-default-footer
        :page.sync="footerPagination.page"
        :items-per-page="footerPagination.itemsPerPage"
        @update:sort-desc="handleSort"
        @page-count="footerPagination.pageCount = $event"
    >
      <!-- ДАТА -->
      <template #[`item.created_at`]="{item}">
      <span>
        {{
          moment
              .parseZone(item.created_at)
              .local()
              .format('YYYY-MM-DD')
        }}
      </span>
      </template>

      <!-- ПОЛЬЗОВАТЕЛЬ -->
      <template #[`item.provider`]="{item}">
        <div v-if="item && item.provider">
        <span class="text--black">
             {{ $t('billing.descriptionText', {plane: capitalising(item.plan), profiles: item.browserProfilesLimit}) }}

        </span>
          <br>
          <small v-if="item.usersLimit && (item.usersLimit-1) !== 0" style="color: #666666; font-size: 13px;">
            {{ item.usersLimit - 1 }} {{ userLimitText(item) }}</small>
        </div>
      </template>

    <!-- СУММА -->
    <template #[`item.sum`]="{item}">
      <span class="text--black">   {{ item.currency ? showSum(item) : item.sum }}</span>
</template>
    <template #[`item.status`]="{item}">
      <span class="text-capitalize text--black">{{ $t('billing.success') }}</span> <br>
      <a class="invoice-link" target="_blank" :href="`${remoteApiUrl}/subscription/invoices/generate/${item.id}?tokenForAuth=${remoteApiToken}`" color="primary">
        {{ $t('billing.viewInvoice') }}</a>
      <br>
    </template>
      <template #footer>
        <v-data-footer
            :options="{
              page: footerOptions.page,
              itemsPerPage: footerPagination.itemsPerPage
            }"
            :pagination="footerPagination"
            @update:options="updateFooterOptions"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import moment from 'moment'
import Cookies from "js-cookie";

export default {
  name: 'BillingMainTable',

  data() {
    return {
      moment
    }
  },

  computed: {
    ...mapGetters({
      invoices: 'billing/invoices',
      profile: 'main/profile',
      loading: 'billing/loading',
      pagination: 'billing/pagination'
    }),

    cols() {
      const cols = []

      cols.push({
        text: this.$t('billing.date'),
        value: 'created_at',
        width: 170
      })
      cols.push({
        text: this.$t('billing.description'),
        value: 'provider',
        sortable: false
      })
      cols.push({
        text: this.$t('billing.invoiceTotal'),
        value: 'sum',
        width: 100,
        sortable: false
      })
      cols.push({
        text: this.$t('billing.status'),
        value: 'status',
        width: 200,
        sortable: false
      })

      return cols
    },

    footerOptions() {
      const options = {}

      options.page = this.pagination.currentPage
      options.itemsPerPage = this.pagination.perPage

      return options
    },

    footerPagination() {
      const pagination = {}

      pagination.page = this.pagination.currentPage
      pagination.itemsPerPage = this.pagination.perPage
      pagination.pageStart = this.pagination.from - 1
      pagination.pageStop = this.pagination.to
      pagination.pageCount = this.pagination.lastPage
      pagination.itemsLength = this.pagination.total

      return pagination
    },

    remoteApiToken () {
      return window.atob(window.decodeURIComponent(Cookies.get('dolphinAntyAccessToken')))
    },

    remoteApiUrl () {
      return process.env.VUE_APP_BASE_API_URL
    }
  },

  created() {
    const payload = {
      page: 1,
      itemsPerPage: 30,
      sort: 'desc'
    }
    this.$store.dispatch('billing/loadInvoices', payload)
  },

  methods: {
    capitalising(data) {
      let capitalized = []
      data.split(' ').forEach(word => {
        capitalized.push(
            word.charAt(0).toUpperCase() +
            word.slice(1).toLowerCase()
        )
      })
      return capitalized.join(' ')
    },
    handleSort(isDesc) {
      console.log(isDesc)
      const payload = {
        page: 1,
        itemsPerPage: 30,
        sort: 'desc'
      }
      if (isDesc[0] !== undefined) {
        payload.sort = isDesc[0] ? 'desc' : 'asc'
      }
      this.$store.dispatch('billing/loadInvoices', payload)
    },

    updateFooterOptions(options) {
      const payload = {
        sort: this.pagination.sort,
        page: options.page,
        itemsPerPage: options.itemsPerPage
      }
      this.$store.dispatch('billing/loadInvoices', payload)
    },

    showSum(item) {
      switch (item.currency.toUpperCase()) {
        case 'RUB':
          return item.sum.toLocaleString('ru-RU', {
            style: 'currency',
            currency: 'RUB',
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
          })
        case 'USD':
          return item.sum.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
          })
      }
    },

    userLimitText (item) {
      return item.usersLimit - 1 > 1 ? this.$tc('billing.usersLimit') : this.$tc('billing.userLimit')
    }
  }
}
</script>
<style lang="scss">


.anty-user-panel-billing-main-table td {
  border-bottom: transparent !important;
}

.anty-user-panel-billing-main-table {
  font-family: Roboto,serif;
  font-weight: 400;
}

.text--black {
  font-size: 14px;
}

.invoice-link:hover {
  text-decoration: none;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  padding-left: 0!important;
  padding-right: 16px!important;
}

</style>
